import { IconProps } from '@chakra-ui/react';
import { InternalPayflipLogo } from './internal-payflip-logo';
import { InternalPayflipLogoMark } from './internal-payflip-logo-mark';
import { InternalPayflipLogoPowered } from './internal-payflip-logo-powered';

type Props = {
  noText?: boolean;
  reseller?: boolean;
} & IconProps;

export function PayflipLogo({
  noText = false,
  reseller = false,
  ...rest
}: Props): JSX.Element {
  if (noText) {
    return <InternalPayflipLogoMark {...rest} />;
  }
  if (reseller) {
    return <InternalPayflipLogoPowered {...rest} />;
  }

  return <InternalPayflipLogo {...rest} />;
}
